import type { Tenant } from '@/api/types';

/**
 * A tenant's brand and legal blocks are objects, or an empty list when not set yet (the contract allows `[]`, PHP's
 * empty array). These read the name either way.
 */
export const brandName = (t: Pick<Tenant, 'brand' | 'slug'>): string =>
    (!Array.isArray(t.brand) &&
        (t.brand as { display_name?: string }).display_name) ||
    t.slug;

export const legalName = (t: Pick<Tenant, 'legal'>): string =>
    (!Array.isArray(t.legal) && (t.legal as { name?: string }).name) || '—';
